var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Divider',{attrs:{"dashed":""}},[_c('span',{staticClass:"divider-text"},[_vm._v(_vm._s(_vm.name))])]),_c('Timeline',_vm._l((_vm.nodes),function(node,i){return _c('TimelineItem',{key:i},[_c('p',{staticClass:"time"},[_vm._v(_vm._s(node.approvalnode.name))]),_c('p',{staticClass:"content"},[_vm._v(_vm._s(node.userDescription))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }